const PROD_API_BASE = 'https://api.wealthy.in/phaser/external-apis/planner/reports/';
const DEV_API_BASE = 'https://api.wealthydev.in/phaser/external-apis/planner/reports/';

function getApiBaseUrl() {
  return process.env.NODE_ENV === 'production' ? PROD_API_BASE : DEV_API_BASE;
}

/**
 * Fetches report data from the API, falling back to local data if fetch fails.
 * @param {string} reportId - The report ID to fetch.
 * @param {object} fallbackData - The fallback data to use if fetch fails.
 * @returns {Promise<object>} - Resolves to the report data.
 */
export async function fetchReportWithFallback(reportId, fallbackData) {
  if (!reportId) {
    return fallbackData;
  }
  try {
    const apiBase = getApiBaseUrl();
    const res = await fetch(`${apiBase}${reportId}/`);
    if (!res.ok) throw new Error('Network response was not ok');
    const json = await res.json();
    return json;
  } catch (err) {
    return fallbackData;
  }
} 